/** Strings for the account settings page (niup-account-settings-page). */
export const settings = {
  // Page shell: header, description, sidebar and shared captions.
  page: {
    title: 'Account settings',
    description: "Here you find all that's needed to manage your account.",
    sidebarAriaLabel: 'Account settings sections',
    lastUpdated: 'Last updated: {date}',
  },
  // Sidebar section labels (SETTINGS_SECTIONS).
  sections: {
    profile: 'Profile',
    password: 'Update password',
    notifications: 'Notifications management',
  },
  // Profile section: card title, subtitle and field labels.
  profileSection: {
    title: 'Profile',
    subtitle: "Edit your profile's information",
    name: 'Name',
    username: 'Username',
    email: 'Email',
  },
  // Update-password section: card title, subtitle, field labels and hint.
  passwordSection: {
    title: 'Update password',
    subtitle: 'Update your password to ensure your account is secure.',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    hint: 'Create a strong password with a mix of letters, numbers, and symbols.',
  },
};
